import dayjs from "dayjs";

export const monthKeyOf = (selectedMonth) => selectedMonth.format("YYYY-MM");

// All calendar days of the month (header columns) — matches getDatesHeaders.
export const getMonthDates = (selectedMonth) => {
    const days = selectedMonth?.daysInMonth();
    return Array.from({ length: days }, (_, i) => selectedMonth.date(i + 1).format("YYYY-MM-DD"));
};

// A coach flag records something that happened, so a future date can never be tagged.
// `dateStr` is YYYY-MM-DD, which compares correctly as a string against the same format.
export const isTaggableDate = (dateStr) => dateStr <= dayjs().format("YYYY-MM-DD");

// Days to actually request: start of month → min(today, end of month) — matches getDatesToQuery.
export const getDatesToQuery = (selectedMonth) => {
    const startOfMonth = selectedMonth.clone().startOf("month");
    const endOfMonth = selectedMonth.clone().endOf("month");
    const minDate = dayjs.min(dayjs(), endOfMonth);
    const dates = [];
    let cur = startOfMonth;
    while (cur <= minDate) {
        dates.push(cur.format("YYYY-MM-DD"));
        cur = cur.add(1, "days");
    }
    return dates;
};
